import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sections-component',
  templateUrl: './sections-component.component.html',
  styleUrls: ['./sections-component.component.scss']
})
export class SectionsComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
